export default "__VITE_ASSET__CZ4xqrK8__"